import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import axios from "axios";
import GuestLayout from "../../Layouts/GuestLayout";

export default function ViewQrCode() {
  const { hash } = useParams(); // Get the hash from the URL
  const navigate = useNavigate();
  const [qrCodeData, setQrCodeData] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchQrCodeData = async () => {
      try {
        const response = await axios.get(`http://localhost:8000/api/secure-qr-code/${hash}`);
        setQrCodeData(response.data.qrCodeData); // Set the QR code data
      } catch (err) {
        console.error("Error fetching QR code:", err);
        setError("Αυτός ο σύνδεσμος δεν είναι έγκυρος ή έχει λήξει.");
        setTimeout(() => {
          navigate("/login");
        }, 5000); // Redirect to login after 5 seconds
      }
    };

    fetchQrCodeData();
  }, [hash, navigate]);

  if (error) {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  return (
    <GuestLayout>
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-2xl mb-4">Ο ασφαλής κωδικός QR σας</h1>
        {qrCodeData ? (
          <>
            <p className="mb-4">Σαρώστε αυτόν τον κωδικό με την εφαρμογή ελέγχου ταυτότητας:</p>
            <QRCodeCanvas value={qrCodeData} size={200} includeMargin={true} />
          </>
        ) : (
          <p>Φόρτωση...</p>
        )}
      </div>
    </GuestLayout>
  );
}
